/**
 * @Author : wzk
 * @Date : 2020/3/17Tuesday12
 * @Last Modified by : wzk
 * @Last Modified time : 2020/3/17Tuesday12
 * @Description: API网关签名脚本
 **/
import CryptoJS from 'crypto-js'

const headersToSign = (headers) => {
  let result = {}
  for (let key in headers) {
    let name = key.toLowerCase()
    if (!name.startsWith('x-ca-')) {
      continue
    }
    if (name === 'x-ca-signature' || name === 'x-ca-signature-headers' || name === 'x-ca-key' || name === 'x-ca-nonce') {
      result[name] = headers[key]
    }
  }
  return result
}

/**
 * 构建urlToSign: `/path?query1=1&query2=2&form1=2&form2=3
 */

const urlToSign = (path, params) => {
  let sortedKeys = Array.from(Object.keys(params)).sort()
  let qs = null
  // for (let k of sortedKeys) {
  //   let s
  //   if ((params[k] && params[k] !== '') || params[k] === 0) {
  //     s = k + '=' + params[k]
  //   } else {
  //     s = k + params[k]
  //   }
  //   qs = qs ? qs + '&' + s : s
  // }
  for (let k of sortedKeys) {
    let s;
    // if (params[k] && params[k] !== '') {
    //     s = k + '=' + params[k]
    // } else {
    //     s = k + params[k]
    // }
    if (params[k] !== null && params[k] !== undefined) {
      if (params[k] !== '') {
        s = k + '=' + params[k];
      } else {
        s = k + params[k];
      }
      qs = qs ? qs + '&' + s : s;
    }
  }
  return qs ? (path + '?' + qs) : path
}
const createUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0
    let v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}
const getParams = (url) => {
  let queryObj = {}
  let reg = /[?&]([^=&#]+)=([^&#]*)/g
  let querys = url.match(reg)
  // console.log('=====querys======', querys);

  if (querys) {
    for (let i in querys) {
      let query = querys[i].split('=')
      let key = query[0].substr(1)
      let value = query[1]
      queryObj[key] ? queryObj[key] = [].concat(queryObj[key], value) : queryObj[key] = value
    }
  }
  return queryObj
}
// API 调用者生成的 UUID，可以结合时间戳防重放。
export const xCaNonce = (xCaNonce) => {
  let nonce = xCaNonce || null
  if (nonce == null) {
    nonce = createUuid()
  }
  return nonce
}
/**
 * 根据Key/Secret生成客户端请求headers签名, headers是大小写敏感的使用是请注意
 */
export const xCaSignature = ({ method, url, appSecret, accept, date, contentType, params, headers }) => {
  let textToSign = ''
  // params = params || {}
  // 参数配置
  if (!params && url.indexOf('?') !== -1) {
    params = getParams(url)
    url = url.split('?')[0]
  } else if (!params) {
    params = {}
  }
  let md5 = ''
  textToSign += `${method}\n`
  textToSign += `${accept}\n`
  textToSign += `${md5}\n`
  textToSign += `${contentType}\n`
  textToSign += `${date}\n`
  let signatureHeaders = headersToSign(headers)
  // console.log('signatureHeaders', signatureHeaders)
  let sortedHeaderNames = Array.from(Object.keys(signatureHeaders)).sort()
  for (let headerName of sortedHeaderNames) {
    textToSign += headerName + ':' + signatureHeaders[headerName] + '\n'
  }
  let reg = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.csdn\.net)/
  // 必须是http开头或者https开头，结尾为'/'
  let path = url.replace(reg, '')
  textToSign = textToSign + urlToSign(path, params)
  // console.log('textToSign\n' + textToSign.replace(/\n/g, '#'))
  // console.log('textToSigasefrn\n' + textToSign)
  // crypto.createHash
  let hash = CryptoJS.HmacSHA256(textToSign, appSecret)
  let signature = hash.toString(CryptoJS.enc.Base64)
  return signature
}
// 提交给服务端签名的header
export const xCaSignatureHeaders = (headers) => {
  let signatureHeaders = headersToSign(headers)
  let signatureHeaderNames
  let sortedHeaderNames = Array.from(Object.keys(signatureHeaders)).sort()
  for (let headerName of sortedHeaderNames) {
    // x-ca-signature不参与服务端签名
    if (headerName !== 'x-ca-signature') {
      signatureHeaderNames = signatureHeaderNames ? signatureHeaderNames + ',' + headerName : headerName
    }
  }
  return signatureHeaderNames
}
